import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";

type AcqInvoiceConfirmDialogsProps = {
  reverseOpen: boolean;
  cancelOpen: boolean;
  reverseLoading: boolean;
  cancelLoading: boolean;
  onReverseOpenChange: (open: boolean) => void;
  onCancelOpenChange: (open: boolean) => void;
  onConfirmReverse: () => void;
  onConfirmCancel: () => void;
};

export function AcqInvoiceConfirmDialogs({
  reverseOpen,
  cancelOpen,
  reverseLoading,
  cancelLoading,
  onReverseOpenChange,
  onCancelOpenChange,
  onConfirmReverse,
  onConfirmCancel,
}: AcqInvoiceConfirmDialogsProps) {
  return (
    <>
      <Dialog open={reverseOpen} onOpenChange={onReverseOpenChange}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Reverse this match?</DialogTitle>
          </DialogHeader>
          <p className="text-sm text-slate-600">
            Restores encumbrance, removes posted expenditure for linked fund lines, and returns this
            invoice to <strong>Draft</strong> so you can fix lines and match again.
          </p>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onReverseOpenChange(false)}>
              Cancel
            </Button>
            <Button
              type="button"
              variant="destructive"
              onClick={onConfirmReverse}
              disabled={reverseLoading}
            >
              {reverseLoading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
              Reverse match
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <Dialog open={cancelOpen} onOpenChange={onCancelOpenChange}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Cancel this invoice?</DialogTitle>
          </DialogHeader>
          <p className="text-sm text-slate-600">
            This voids the draft. It cannot be undone. Matched invoices cannot be cancelled here.
          </p>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onCancelOpenChange(false)}>
              Keep draft
            </Button>
            <Button
              type="button"
              variant="destructive"
              onClick={onConfirmCancel}
              disabled={cancelLoading}
            >
              {cancelLoading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
              Cancel invoice
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
